(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rc-article-contenu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function demarrer() {
    var art = document.querySelector('[data-rc-art]');
    if (!art || art.dataset.rcPret) return;
    art.dataset.rcPret = '1';
    var contenu = art.querySelector('[data-rc-art-contenu]');

    /* Barre de progression de lecture */
    var jauge = document.querySelector('[data-rc-art-jauge]');
    if (jauge && contenu) {
      var t = 0;
      var maj = function () {
        var r = contenu.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.6;
        var p = total > 0 ? (window.innerHeight * 0.4 - r.top) / total : 0;
        p = Math.max(0, Math.min(1, p));
        jauge.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      };
      window.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(maj); }, { passive: true });
      window.addEventListener('resize', maj);
      maj();
    }

    /* Sommaire : partie en cours (ordinateur) et fermeture du sommaire mobile au clic */
    var liens = art.querySelectorAll('.rc-art__som a[data-rc-som]');
    if (liens.length && contenu && 'IntersectionObserver' in window) {
      var titres = contenu.querySelectorAll('h2[id]');
      var actif = function (id) { liens.forEach(function (a) { a.classList.toggle('is-on', a.dataset.rcSom === id); }); };
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) actif(e.target.id); });
      }, { rootMargin: '-90px 0px -70% 0px' });
      titres.forEach(function (h) { io.observe(h); });
    }
    var mob = art.querySelector('[data-rc-som-mob]');
    if (mob) mob.addEventListener('click', function (e) { if (e.target.closest('a')) mob.open = false; });

    /* Copier le lien */
    var btn = art.querySelector('[data-rc-copier]');
    if (btn) {
      var lib = btn.querySelector('[data-rc-copier-lib]');
      var etat = art.querySelector('[data-rc-copier-etat]');
      btn.addEventListener('click', function () {
        var url = window.location.href.split('#')[0];
        var fini = function () {
          btn.classList.add('is-ok'); lib.textContent = 'Lien copié'; if (etat) etat.textContent = 'Lien de l’article copié';
          setTimeout(function () { btn.classList.remove('is-ok'); lib.textContent = 'Copier le lien'; if (etat) etat.textContent = ''; }, 2000);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(fini, function () { secours(url); fini(); });
        } else { secours(url); fini(); }
      });
    }
    function secours(url) {
      var z = document.createElement('textarea');
      z.value = url; z.setAttribute('readonly', ''); z.style.position = 'fixed'; z.style.opacity = '0';
      document.body.appendChild(z); z.select();
      try { document.execCommand('copy'); } catch (e) {}
      z.remove();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('shopify:section:load', demarrer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rcTiroir) return;
    window.__rcTiroir = true;
    /* Accessibilité seulement (aucun état peint) : focus sur « Fermer » à l'ouverture, Échap pour fermer. */
    document.addEventListener('cart:open', function () {
      setTimeout(function () {
        var b = document.querySelector('cart-drawer.rc-tiroir.is-open .rc-tiroir__fermer');
        if (b) b.focus({ preventScroll: true });
      }, 80);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var t = document.querySelector('cart-drawer.rc-tiroir.is-open');
      if (t && typeof t.close === 'function') t.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-faq-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sansAccent = function (s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function equiper(racine) {
    if (!racine || racine.dataset.rcPret) return;
    racine.dataset.rcPret = '1';
    var champ = racine.querySelector('[data-rc-faq-q]');
    var effacer = racine.querySelector('[data-rc-faq-effacer]');
    var resultat = racine.querySelector('[data-rc-faq-resultat]');
    var vide = racine.querySelector('[data-rc-faq-vide]');
    var groupes = Array.prototype.slice.call(racine.querySelectorAll('[data-rc-faq-groupe]'));
    var items = Array.prototype.slice.call(racine.querySelectorAll('[data-rc-faq-item]'));
    var cats = Array.prototype.slice.call(racine.querySelectorAll('[data-rc-faq-cat]'));
    items.forEach(function (d) { d._rcTexte = sansAccent(d.textContent); });

    /* Recherche en direct */
    var t;
    function filtrer() {
      var q = sansAccent(champ.value.trim());
      var mots = q.split(/\s+/).filter(Boolean);
      var n = 0;
      items.forEach(function (d) {
        var ok = !mots.length || mots.every(function (m) { return d._rcTexte.indexOf(m) !== -1; });
        d.hidden = !ok;
        if (ok) n++;
      });
      groupes.forEach(function (g) { g.hidden = !g.querySelector('[data-rc-faq-item]:not([hidden])'); });
      if (effacer) effacer.hidden = !champ.value;
      racine.classList.toggle('is-recherche', mots.length > 0);
      if (vide) vide.hidden = !(mots.length && n === 0);
      if (resultat) resultat.textContent = mots.length ? (n === 0 ? 'Aucune question trouvée' : n + (n > 1 ? ' questions correspondent' : ' question correspond') + ' à « ' + champ.value.trim() + ' »') : '';
    }
    if (champ) {
      champ.addEventListener('input', function () { clearTimeout(t); t = setTimeout(filtrer, 120); });
      champ.addEventListener('keydown', function (e) { if (e.key === 'Escape') { champ.value = ''; filtrer(); } });
    }
    if (effacer) effacer.addEventListener('click', function () { champ.value = ''; filtrer(); champ.focus(); });

    /* Puces : défilement doux vers la catégorie (la recherche est remise à zéro) */
    cats.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var cible = document.getElementById(a.dataset.rcFaqCat);
        if (!cible) return;
        e.preventDefault();
        if (champ && champ.value) { champ.value = ''; filtrer(); }
        cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + cible.id);
      });
    });

    /* Catégorie en cours (colonne collante sur ordinateur) */
    if (cats.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          cats.forEach(function (a) { a.classList.toggle('is-on', a.dataset.rcFaqCat === e.target.id); });
        });
      }, { rootMargin: '-100px 0px -60% 0px' });
      groupes.forEach(function (g) { io.observe(g); });
    }

    /* Lien direct vers une question : on l'ouvre */
    function ouvrirAncre() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var d = document.getElementById(id);
      if (d && d.matches('[data-rc-faq-item]')) { d.open = true; d.scrollIntoView({ block: 'start' }); }
    }
    ouvrirAncre();
    window.addEventListener('hashchange', ouvrirAncre);
  }
  function demarrer() { document.querySelectorAll('[data-rc-faq]').forEach(equiper); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-rc-faq]'); if (r) equiper(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rcPied) return;
    window.__rcPied = true;
    /* Accordéon mobile du pied de page. Sur ordinateur, les colonnes sont ouvertes : les titres
       sortent de l'ordre de tabulation et annoncent « ouvert ». */
    var mq = window.matchMedia('(max-width: 749px)');
    function etat() {
      document.querySelectorAll('.rc-pied__t-btn').forEach(function (b) {
        var col = b.closest('[data-rc-pied-col]');
        if (mq.matches) { b.removeAttribute('tabindex'); b.setAttribute('aria-expanded', col.classList.contains('is-ouvert') ? 'true' : 'false'); }
        else { b.setAttribute('tabindex', '-1'); b.setAttribute('aria-expanded', 'true'); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', etat); else etat();
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(etat);
    document.addEventListener('shopify:section:load', etat);
    document.addEventListener('click', function (e) {
      var b = e.target instanceof Element ? e.target.closest('.rc-pied__t-btn') : null;
      if (!b || !mq.matches) return;
      var col = b.closest('[data-rc-pied-col]');
      var ouvert = !col.classList.contains('is-ouvert');
      col.classList.toggle('is-ouvert', ouvert);
      b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rcTete) return;
    window.__rcTete = true;

    var verrou = 'overflow-hidden'; /* verrou de défilement du thème FullStack : jamais un second */
    var dernierBurger = null;

    function tiroirPanier() { return document.querySelector('cart-drawer'); }

    /* ---------- Sous-menus ordinateur ---------- */
    function fermerSous(sauf) {
      document.querySelectorAll('.rc-tete__i.is-ouvert').forEach(function (li) {
        if (li === sauf) return;
        li.classList.remove('is-ouvert');
        var b = li.querySelector('[data-rc-sous]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    function basculerSous(btn) {
      var li = btn.closest('.rc-tete__i');
      var ouvrir = !li.classList.contains('is-ouvert');
      fermerSous(li);
      li.classList.toggle('is-ouvert', ouvrir);
      btn.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
    }

    /* ---------- Panneau mobile ---------- */
    function ouvrirMob(btn) {
      var mob = document.getElementById(btn.getAttribute('aria-controls'));
      if (!mob) return;
      dernierBurger = btn;
      mob.removeAttribute('inert');
      mob.classList.add('is-ouvert');
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add(verrou);
      var f = mob.querySelector('.rc-tete__mob-tete [data-rc-mob-fermer]');
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
    function fermerMob() {
      var mob = document.querySelector('[data-rc-mob].is-ouvert');
      if (!mob) return;
      mob.classList.remove('is-ouvert');
      mob.setAttribute('inert', '');
      var t = tiroirPanier();
      if (!t || !t.classList.contains('is-open')) document.body.classList.remove(verrou);
      if (dernierBurger) { dernierBurger.setAttribute('aria-expanded', 'false'); dernierBurger.focus(); }
    }

    /* ---------- Recherche ---------- */
    function basculerRech(btn, forcer) {
      var p = document.getElementById(btn.getAttribute('aria-controls'));
      if (!p) return;
      var ouvrir = typeof forcer === 'boolean' ? forcer : p.hidden;
      p.hidden = !ouvrir;
      btn.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
      if (ouvrir) { var i = p.querySelector('input[type="search"]'); if (i) i.focus(); }
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var panier = t.closest('[data-rc-panier]');
      if (panier) {
        if (tiroirPanier()) { e.preventDefault(); fermerMob(); document.dispatchEvent(new Event('cart:open')); }
        return;
      }
      var sous = t.closest('[data-rc-sous]');
      if (sous) { e.preventDefault(); basculerSous(sous); return; }
      if (!t.closest('.rc-tete__i--sous')) fermerSous(null);

      var burger = t.closest('[data-rc-mob-ouvrir]');
      if (burger) { ouvrirMob(burger); return; }
      if (t.closest('[data-rc-mob-fermer]')) { fermerMob(); return; }

      var rech = t.closest('[data-rc-rech-btn]');
      if (rech) { basculerRech(rech); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var ouvert = document.querySelector('.rc-tete__i.is-ouvert');
      if (ouvert) { fermerSous(null); var b = ouvert.querySelector('[data-rc-sous]'); if (b) b.focus(); return; }
      if (document.querySelector('[data-rc-mob].is-ouvert')) { fermerMob(); return; }
      var r = document.querySelector('[data-rc-rech-btn][aria-expanded="true"]');
      if (r) { basculerRech(r, false); r.focus(); }
    });

    /* Le focus clavier qui sort d'un sous-menu le referme. */
    document.addEventListener('focusout', function (e) {
      var li = e.target instanceof Element ? e.target.closest('.rc-tete__i.is-ouvert') : null;
      if (li && !(e.relatedTarget && li.contains(e.relatedTarget))) {
        li.classList.remove('is-ouvert');
        var b = li.querySelector('[data-rc-sous]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });

    /* Passage en ordinateur avec le panneau mobile ouvert : on libère le verrou. */
    var mq = window.matchMedia('(min-width: 900px)');
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (m) { if (m.matches) fermerMob(); });

    /* ---------- Compteur + ouverture après ajout ----------
       Dans FullStack, c'est <cart-icon> (en-tête du thème) qui ouvrait le tiroir après un ajout depuis la fiche
       produit ou l'ajout rapide, et qui tenait le compteur. Notre en-tête reprend ces deux rôles ici.
       Les ajouts RC.ajouter() (rc.js) ouvrent déjà le tiroir eux-mêmes. */
    function peindre(n) {
      document.querySelectorAll('[data-rc-compteur]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    }
    document.addEventListener('cart:updated', function (e) {
      var d = e.detail || {};
      var n = d.resource && typeof d.resource.item_count === 'number' ? d.resource.item_count
        : (d.data && typeof d.data.itemCount === 'number' ? d.data.itemCount : null);
      if (n === null) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { peindre(c.item_count); }).catch(function () {});
      } else {
        peindre(n);
      }
      var src = d.data && d.data.source;
      var tete = document.querySelector('[data-rc-tete]');
      if ((src === 'product-form' || src === 'quick-add') && tete && tete.dataset.rcOuvrirAjout === 'true' && tiroirPanier()) {
        document.dispatchEvent(new Event('cart:open'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-home-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* Flèches gauche / droite entre les onglets (le clic est géré par rc.js). */
  document.addEventListener('keydown', (e) => {
    const t = e.target.closest?.('.rc-guide__onglet');
    if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    const tous = [...t.parentElement.querySelectorAll('[role="tab"]')];
    const i = tous.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
    const c = tous[(i + tous.length) % tous.length];
    c.focus(); c.click(); e.preventDefault();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-home-pourquoi"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function compter(el) {
    const cible = parseInt(el.dataset.rcHomeCompte, 10);
    if (!cible || reduit) return;
    const duree = 1100;
    const t0 = performance.now();
    el.textContent = '0';
    const pas = (t) => {
      const k = Math.min(1, (t - t0) / duree);
      el.textContent = String(Math.round(cible * (1 - Math.pow(1 - k, 3))));
      if (k < 1) requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  }
  function equiper(racine) {
    const els = racine.querySelectorAll('[data-rc-home-compte]:not([data-rc-pret])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { io.unobserve(e.target); setTimeout(() => compter(e.target), 350); }
    }), { threshold: 0.6 });
    els.forEach((el) => { el.dataset.rcPret = '1'; io.observe(el); });
  }
  equiper(document);
  document.addEventListener('shopify:section:load', (e) => equiper(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-product-achat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fmtDate = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });

    /* Jours fériés français (fixes + liés à Pâques) */
    function paques(an) {
      const a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4;
      const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const mois = Math.floor((h + l - 7 * m + 114) / 31), jour = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(an, mois - 1, jour);
    }
    const feries = {};
    function estFerie(d) {
      const an = d.getFullYear();
      if (!feries[an]) {
        const p = paques(an), cle = (x) => `${x.getMonth() + 1}-${x.getDate()}`, plus = (n) => new Date(an, p.getMonth(), p.getDate() + n);
        feries[an] = new Set(['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25', cle(plus(1)), cle(plus(39)), cle(plus(50))]);
      }
      return feries[an].has(`${d.getMonth() + 1}-${d.getDate()}`);
    }
    function joursOuvres(n) {
      const d = new Date();
      let k = 0;
      while (k < n) {
        d.setDate(d.getDate() + 1);
        const j = d.getDay();
        if (j !== 0 && j !== 6 && !estFerie(d)) k++;
      }
      return d;
    }

    function equiperGalerie(racine) {
      const piste = racine.querySelector('[data-rc-piste]');
      if (!piste) return { allerMedia() {} };
      const vues = [...piste.children];
      const vignettes = [...racine.querySelectorAll('[data-rc-vignette]')];
      const rangee = racine.querySelector('[data-rc-vignettes]');
      const prec = racine.querySelector('[data-rc-prec]');
      const suiv = racine.querySelector('[data-rc-suiv]');
      const index = () => Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
      const aller = (i, doux = true) => {
        i = Math.max(0, Math.min(vues.length - 1, i));
        piste.scrollTo({ left: i * piste.clientWidth, behavior: doux ? 'smooth' : 'auto' });
        marquer(i);
      };
      function marquer(i) {
        vignettes.forEach((v, k) => v.setAttribute('aria-current', k === i ? 'true' : 'false'));
        if (prec) prec.disabled = i <= 0;
        if (suiv) suiv.disabled = i >= vues.length - 1;
        const v = vignettes[i];
        if (v && rangee) {
          const g = v.offsetLeft - rangee.offsetLeft, d = g + v.offsetWidth;
          if (g < rangee.scrollLeft) rangee.scrollTo({ left: g - 8, behavior: 'smooth' });
          else if (d > rangee.scrollLeft + rangee.clientWidth) rangee.scrollTo({ left: d - rangee.clientWidth + 8, behavior: 'smooth' });
        }
      }
      let raf;
      piste.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => marquer(index())); }, { passive: true });
      vignettes.forEach((v, k) => v.addEventListener('click', () => aller(k)));
      prec?.addEventListener('click', () => aller(index() - 1));
      suiv?.addEventListener('click', () => aller(index() + 1));
      piste.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); aller(index() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); aller(index() + 1); }
      });
      marquer(0);

      /* Zoom plein écran */
      const lb = racine.closest('[data-rc-pdp]').querySelector('[data-rc-lb]');
      if (lb) {
        const lbPiste = lb.querySelector('[data-rc-lb-piste]');
        const lbIndex = () => Math.round(lbPiste.scrollLeft / Math.max(1, lbPiste.clientWidth));
        const lbAller = (i) => { dezoomer(); lbPiste.scrollTo({ left: Math.max(0, Math.min(vues.length - 1, i)) * lbPiste.clientWidth, behavior: 'smooth' }); };
        const dezoomer = () => { lb.classList.remove('is-zoom'); lb.querySelectorAll('.is-zoom').forEach((f) => f.classList.remove('is-zoom')); };
        const fermer = () => { dezoomer(); const i = lbIndex(); lb.close(); aller(i, false); };
        racine.querySelectorAll('[data-rc-zoom]').forEach((b) => b.addEventListener('click', () => {
          const i = Number(b.dataset.rcZoom);
          lb.showModal();
          document.body.classList.add('overflow-hidden');
          lbPiste.scrollTo({ left: i * lbPiste.clientWidth, behavior: 'auto' });
          requestAnimationFrame(() => lbPiste.scrollTo({ left: i * lbPiste.clientWidth, behavior: 'auto' }));
        }));
        lb.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
        lb.querySelector('[data-rc-lb-fermer]').addEventListener('click', fermer);
        lb.querySelector('[data-rc-lb-prec]')?.addEventListener('click', () => lbAller(lbIndex() - 1));
        lb.querySelector('[data-rc-lb-suiv]')?.addEventListener('click', () => lbAller(lbIndex() + 1));
        lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') lbAller(lbIndex() - 1);
          if (e.key === 'ArrowRight') lbAller(lbIndex() + 1);
        });
        lb.addEventListener('cancel', (e) => { e.preventDefault(); fermer(); });
        lb.querySelectorAll('.rc-pdp__lb-vue').forEach((f) => {
          const img = f.querySelector('img');
          const origine = (e) => {
            const r = img.getBoundingClientRect();
            img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          };
          img.addEventListener('click', (e) => {
            const on = !f.classList.contains('is-zoom');
            dezoomer();
            if (on) { origine(e); f.classList.add('is-zoom'); lb.classList.add('is-zoom'); }
          });
          img.addEventListener('pointermove', (e) => { if (f.classList.contains('is-zoom')) origine(e); });
          f.addEventListener('click', (e) => { if (e.target === f) fermer(); });
        });
      }

      return {
        allerMedia(id) {
          const i = vues.findIndex((v) => v.dataset.mediaId === String(id));
          if (i >= 0) aller(i);
        },
      };
    }

    function equiper(sec) {
      if (sec.dataset.rcPret) return;
      sec.dataset.rcPret = '1';
      const galerie = equiperGalerie(sec.querySelector('[data-rc-galerie]'));
      const variantes = JSON.parse(sec.querySelector('[data-rc-variantes]').textContent || '[]');
      const form = sec.querySelector('[data-rc-form]');
      const champId = sec.querySelector('[data-rc-id]');
      const champQte = sec.querySelector('[data-rc-qte]');
      const bouton = sec.querySelector('[data-rc-bouton]');
      const boutonTxt = sec.querySelector('[data-rc-bouton-txt]');
      const texteBouton = bouton.dataset.texte || 'Ajouter au panier';
      const etat = sec.querySelector('[data-rc-etat]');
      const prix = sec.querySelector('[data-rc-prix]');
      const options = [...sec.querySelectorAll('[data-rc-opt]')];
      const collant = sec.querySelector('[data-rc-collant]');
      let courante = variantes.find((v) => String(v.id) === champId.value) || variantes[0];
      let sel = courante ? courante.o.slice() : [];

      const trouver = (s) => variantes.find((v) => v.o.every((x, i) => x === s[i]));

      function choisir(k, val) {
        const s = sel.slice();
        s[k] = val;
        let v = trouver(s);
        if (!v || !v.d) {
          const score = (c) => c.o.reduce((n, x, i) => n + (x === sel[i] ? 1 : 0), 0);
          const cands = variantes.filter((c) => c.o[k] === val).sort((a, b) => (b.d - a.d) || (score(b) - score(a)));
          if (!v || (cands[0] && cands[0].d)) v = cands[0] || v;
        }
        if (!v) return;
        sel = v.o.slice();
        maj(v, true);
      }

      function maj(v, changerImage) {
        courante = v;
        champId.value = v.id;
        prix.textContent = v.p;
        options.forEach((fs) => {
          const k = Number(fs.dataset.rcOpt);
          const lab = fs.querySelector('[data-rc-opt-lab]');
          if (lab) lab.textContent = sel[k];
          const boutons = [...fs.querySelectorAll('[data-rc-valeur]')];
          const prixVal = [];
          boutons.forEach((b) => {
            const s = sel.slice();
            s[k] = b.dataset.rcValeur;
            const c = trouver(s);
            b.setAttribute('aria-pressed', b.dataset.rcValeur === sel[k] ? 'true' : 'false');
            b.classList.toggle('is-off', !c || !c.d);
            const small = b.querySelector('[data-rc-case-prix]');
            if (small) { small.textContent = c ? c.p : ''; prixVal.push(c ? c.p : ''); }
          });
          if (fs.dataset.rcOptType === 'cases') {
            const differents = new Set(prixVal.filter(Boolean)).size > 1;
            fs.querySelectorAll('[data-rc-case-prix]').forEach((s) => { s.hidden = !differents; });
          }
        });
        bouton.setAttribute('aria-disabled', v.d ? 'false' : 'true');
        collant?.querySelector('[data-rc-collant-btn]')?.setAttribute('aria-disabled', v.d ? 'false' : 'true');
        boutonTxt.textContent = v.d ? texteBouton : 'Épuisé dans cette version';
        etat.textContent = '';
        if (collant) {
          collant.querySelector('[data-rc-collant-prix]').textContent = v.p;
          const s = collant.querySelector('[data-rc-collant-sel]');
          if (s) s.textContent = ' · ' + v.o.join(' · ');
          const img = collant.querySelector('[data-rc-collant-img]');
          if (img && v.i) { img.src = v.i; img.removeAttribute('srcset'); }
        }
        if (changerImage) {
          if (v.m) galerie.allerMedia(v.m);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      options.forEach((fs) => {
        const k = Number(fs.dataset.rcOpt);
        fs.querySelectorAll('[data-rc-valeur]').forEach((b) => b.addEventListener('click', () => choisir(k, b.dataset.rcValeur)));
      });
      if (courante) maj(courante, false);

      /* Quantité */
      const borne = (n) => Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      sec.querySelector('[data-rc-moins]').addEventListener('click', () => { champQte.value = borne(champQte.value - 1); });
      sec.querySelector('[data-rc-plus]').addEventListener('click', () => { champQte.value = borne(Number(champQte.value) + 1); });
      champQte.addEventListener('change', () => { champQte.value = borne(champQte.value); });

      /* Option manquante ou version épuisée : jamais de bouton muet */
      let minuteur;
      function signaler(b, txtEl) {
        const fs = options.find((f) => f.querySelector('[aria-pressed="true"].is-off')) || options[0];
        const nom = fs ? fs.querySelector('legend').firstChild.textContent.replace(':', '').trim() : '';
        const court = b !== bouton;
        const message = court ? 'Indisponible' : (fs ? 'Choisir une autre version' : 'Épuisé pour le moment');
        etat.textContent = fs ? `Cette version est épuisée pour le moment. Choisissez une autre option dans « ${nom} ».` : 'Ce modèle est épuisé pour le moment.';
        const avant = txtEl.textContent;
        txtEl.textContent = message;
        clearTimeout(minuteur);
        minuteur = setTimeout(() => { txtEl.textContent = avant; }, 1500);
        if (fs) {
          fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
          fs.classList.remove('is-signal'); void fs.offsetWidth; fs.classList.add('is-signal');
        }
      }
      async function ajouter(b, txtEl) {
        if (!courante || !courante.d) { signaler(b, txtEl); return; }
        if (window.RC && typeof window.RC.ajouter === 'function') {
          etat.textContent = '';
          const panier = await window.RC.ajouter(courante.id, borne(champQte.value), b);
          if (!panier) etat.textContent = `Ajout impossible pour le moment${b.title ? ' : ' + b.title : ''}. Réessayez dans un instant.`;
        } else form.submit();
      }
      form.addEventListener('submit', (e) => { e.preventDefault(); ajouter(bouton, boutonTxt); });

      /* Dates de livraison */
      const liv = sec.querySelector('[data-rc-livraison]');
      if (liv) {
        liv.querySelector('[data-rc-liv1]').textContent = fmtDate(joursOuvres(Number(liv.dataset.min) || 7));
        liv.querySelector('[data-rc-liv2]').textContent = fmtDate(joursOuvres(Number(liv.dataset.max) || 12));
        liv.hidden = false;
      }

      /* Note → avis */
      sec.querySelector('[data-rc-vers-avis]')?.addEventListener('click', (e) => {
        const cible = document.getElementById('avis');
        if (!cible) return;
        e.preventDefault();
        cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(history.state, '', '#avis');
      });

      /* Barre collante : visible seulement quand le bouton principal est sorti de l'écran par le haut */
      if (collant && 'IntersectionObserver' in window) {
        const btnC = collant.querySelector('[data-rc-collant-btn]');
        btnC.addEventListener('click', () => ajouter(btnC, btnC.querySelector('span')));
        new IntersectionObserver(([e]) => {
          const on = !e.isIntersecting && e.boundingClientRect.top < 0;
          collant.classList.toggle('is-on', on);
          collant.setAttribute('aria-hidden', on ? 'false' : 'true');
          collant.inert = !on;
        }).observe(bouton);
      }
    }

    const tout = (r = document) => r.querySelectorAll('[data-rc-pdp]').forEach(equiper);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => tout());
    else tout();
    document.addEventListener('shopify:section:load', (e) => tout(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-product-similaires"] && !Shopify.designMode) return;
  try {
    
  (() => {
    async function charger(sec) {
      if (sec.dataset.rcPret) return;
      sec.dataset.rcPret = '1';
      const corps = sec.querySelector('[data-rc-sim-corps]');
      const vide = () => !corps.querySelector('.rc-card');
      if (vide()) sec.hidden = true;
      const url = sec.dataset.url;
      if (!url) return;
      try {
        const r = await fetch(url);
        if (!r.ok) return;
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const recos = doc.querySelector('[data-rc-sim-recos]');
        if (recos && recos.querySelector('.rc-card')) {
          corps.innerHTML = '';
          corps.appendChild(document.importNode(recos, true));
          sec.hidden = false;
          if (window.RC && window.RC.equiper) window.RC.equiper(corps);
        }
      } catch (e) {
        /* repli déjà affiché */
      } finally {
        if (vide()) sec.hidden = true;
      }
    }
    const tout = (r = document) => r.querySelectorAll('[data-rc-sim]').forEach(charger);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => tout());
    else tout();
    document.addEventListener('shopify:section:load', (e) => tout(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
